import classNames from 'classnames';
import { OpenFlag } from 'api/resort/types';
import { formatDateFromStr, SHORT_DATE_FORMAT } from 'util/formatDate';
import { OpenStatus } from 'components/blocks/OpenStatus';

import cellStyles from './styles.module.scss';

interface IClosingDateCellProps {
  openFlag?: OpenFlag
  closingDate?: string
  noValue: string
}

const ClosingDateCell = ({ openFlag, closingDate, noValue }: IClosingDateCellProps) => {
  const isOpen = openFlag !== OpenFlag.PermanentlyClosed && openFlag !== OpenFlag.Closed;

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      {isOpen
        ? <span>{formatDateFromStr(closingDate, SHORT_DATE_FORMAT) || noValue}</span>
        : (<OpenStatus flag={openFlag} />)}
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>
    </span>
  );
};

export default ClosingDateCell;
